export const fieldOptions = {
    cancerStage: {options: [0, 1, 2, 3, 4]},
    psychNumMedications: {options: ['0', '1', '2', '3', 'More than 3']},
    bpNumMedications: {
        options: ['None', '1', '2', '3', 'More than 3', '1 to 2', '3 to 4', 'More than 4'],
    },
    cholesterolReadingAlt: {options: [1, 2, 3, 4, 5, 6]},
    type1Treatment: {options: ['Diet exercise only', 'Medication', 'Insulin']},
    type2Treatment: {options: ['Diet exercise only', 'Medication', 'Insulin']},
    anxietySeverity: {options: ['mild', 'moderate', 'severe']},
    depressionSeverity: {options: ['mild', 'moderate', 'severe']},
    asthmaSeverity: {options: ['mild', 'moderate', 'severe']},
    sleepapneaSeverity: {options: ['mild', 'moderate', 'severe']},
    enlargedprostateCancerous: {options: ['benign', 'melignant']},
    enlargedprostateDiagnosis: {
        options: ['cancerous', 'pre-cancerous', 'malignant', 'pre-malignant'],
    },
    ulcerSurgery: {
        options: ['cancerous', 'pre-cancerous', 'malignant', 'pre-malignant'],
    },
    allergiesSeverity: {options: ['mild', 'moderate', 'severe']},
    gerdBiopsyResults: {
        options: ['cancerous', 'pre-cancerous', 'malignant', 'pre-malignant'],
    },
    ocdCondition: {
        options: ['medical tests', 'investigations', 'test results', 'referral to hospital'],
    },
    pagetCondition: {
        options: ['medical tests', 'investigations', 'test results', 'referral to hospital', 'surgery'],
    },
    hypoglycemiaHistory: {options: ['diabetes', 'pre-diabetes', 'high blood sugar']},
    hyperkalemiaElevatedSugar: {
        options: ['Do you have a history of diabetes', 'pre-diabetes', 'or high blood sugar?'],
    },
    opioidMember: {
        options: ['AA (Alcoholics Anonymous)', 'NA (Narcotics Anonymous)', 'none'],
    },
    ptsdSeverity: {options: ['mild', 'moderate', 'severe']},
    hypokalemiaElevatedSugar: {
        options: ['Do you have a history of diabetes', 'pre-diabetes', 'or high blood sugar?'],
    },
    tumorDiagnosisType: {options: ['cancerous', 'pre-cancerous', 'malignant', 'benign']},
    polypBiopsyResults: {
        options: ['cancerous', 'pre-cancerous', 'malignant', 'pre-malignant'],
    },
    autismSpectrumDisorderSeverity: {
        options: ['Mild', 'Moderate', 'Severe'],
    },
};
